let ctx = null;
const KEY = "ananawi_sound";

export const soundOn = () => localStorage.getItem(KEY) !== "off";
export const setSoundOn = (on) => localStorage.setItem(KEY, on ? "on" : "off");

const ac = () => {
  if (!ctx) {
    const C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    ctx = new C();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (c, { type = "sine", from, to, start = 0, dur = 0.2, vol = 0.18 }) => {
  const t0 = c.currentTime + start;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(from, t0);
  o.frequency.exponentialRampToValueAtTime(to, t0 + dur);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(vol, t0 + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  o.connect(g).connect(c.destination);
  o.start(t0);
  o.stop(t0 + dur + 0.05);
};

const SOUNDS = {
  boing: (c) => {
    tone(c, { type: "triangle", from: 160, to: 620, dur: 0.18 });
    tone(c, { type: "triangle", from: 620, to: 260, start: 0.16, dur: 0.28, vol: 0.12 });
  },
  sparkle: (c) => [1046, 1318, 1568, 2093].forEach((f, i) => tone(c, { from: f, to: f * 1.01, start: i * 0.07, dur: 0.25, vol: 0.1 })),
  kiss: (c) => {
    tone(c, { from: 500, to: 1400, dur: 0.12, vol: 0.14 });
    tone(c, { type: "triangle", from: 900, to: 300, start: 0.12, dur: 0.18, vol: 0.08 });
  },
  giggle: (c) => [0, 1, 2, 3, 4].forEach((i) => tone(c, { type: "triangle", from: 700 + i * 60, to: 950 + i * 60, start: i * 0.085, dur: 0.07, vol: 0.12 })),
  pop: (c) => tone(c, { from: 400, to: 900, dur: 0.08, vol: 0.1 }),
  snore: (c) => {
    tone(c, { type: "sawtooth", from: 90, to: 70, dur: 0.6, vol: 0.05 });
    tone(c, { from: 600, to: 1200, start: 0.7, dur: 0.35, vol: 0.04 });
  },
  wake: (c) => {
    tone(c, { from: 300, to: 900, dur: 0.15, vol: 0.12 });
    tone(c, { from: 900, to: 1300, start: 0.15, dur: 0.1, vol: 0.1 });
  },
  clap: (c) => {
    const len = Math.floor(c.sampleRate * 0.06);
    const buf = c.createBuffer(1, len, c.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < len; i += 1) d[i] = (Math.random() * 2 - 1) * (1 - i / len) ** 3;
    [0, 0.16, 0.32, 0.48, 0.6, 0.72].forEach((s) => {
      const src = c.createBufferSource();
      src.buffer = buf;
      const bp = c.createBiquadFilter();
      bp.type = "bandpass";
      bp.frequency.value = 1400 + Math.random() * 600;
      const g = c.createGain();
      g.gain.value = 0.5;
      src.connect(bp).connect(g).connect(c.destination);
      src.start(c.currentTime + s);
    });
    [784, 988, 1175].forEach((f, i) => tone(c, { from: f, to: f, start: 0.8 + i * 0.08, dur: 0.2, vol: 0.08 }));
  },
};

export const play = (name) => {
  if (!soundOn()) return;
  const c = ac();
  if (!c || c.state !== "running" || !SOUNDS[name]) return;
  SOUNDS[name](c);
};

export const unlockAudio = () => {
  if (soundOn()) ac();
};

export const getCtx = () => ac();
